import { Component, type ReactNode } from 'react';

interface PaymentErrorBoundaryState {
  hasError: boolean;
}

export class PaymentErrorBoundary extends Component<
  { children: ReactNode },
  PaymentErrorBoundaryState
> {
  override state: PaymentErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): PaymentErrorBoundaryState {
    return { hasError: true };
  }

  override render(): ReactNode {
    if (this.state.hasError) {
      return (
        <div role="alert">
          <p>Something went wrong loading the payment form.</p>
          <button
            type="button"
            onClick={(): void => this.setState({ hasError: false })}
            className="w-full rounded-md bg-brand px-4 py-2.5 text-sm font-semibold text-white hover:bg-brand-dark disabled:cursor-not-allowed disabled:opacity-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand"
          >
            Try again
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}
